import { useState } from "react";
import { Menu, X } from "lucide-react";
import { LogoMark } from "./Logo";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
    { id: "home", label: "Home", testid: "nav-link-home" },
    { id: "about", label: "About", testid: "nav-link-about" },
    { id: "practice-areas", label: "Practice Areas", testid: "nav-link-practice-areas" },
    { id: "attorney", label: "Attorney", testid: "nav-link-attorney" },
    { id: "testimonials", label: "Testimonials", testid: "nav-link-testimonials" },
    { id: "contact", label: "Contact", testid: "nav-link-contact" },
];

const Header = () => {
    const [open, setOpen] = useState(false);

    const go = (id) => {
        setOpen(false);
        scrollToSection(id);
    };

    return (
        <header className="fixed top-0 left-0 right-0 z-50 bg-white/92 backdrop-blur-md border-b border-slate-200/80">
            <div className="max-w-6xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
                <button
                    data-testid="nav-logo"
                    onClick={() => go("home")}
                    className="flex items-center gap-3 cursor-pointer"
                    aria-label="Dan Rosengarten Law Firm — home"
                >
                    <LogoMark size={38} />
                    <span className="text-left leading-tight">
                        <span className="block font-serif-display text-[15px] sm:text-base tracking-wide text-[#0B192C]">
                            DAN ROSENGARTEN
                        </span>
                        <span className="block font-mono-label text-[9px] tracking-[0.32em] text-[#B89047] uppercase">
                            Law Firm
                        </span>
                    </span>
                </button>

                <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={l.testid}
                            onClick={() => go(l.id)}
                            className="text-[13px] font-medium tracking-wide text-slate-600 hover:text-[#0B192C] transition-colors duration-300 cursor-pointer"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="nav-cta-schedule"
                        onClick={() => go("contact")}
                        className="ml-2 text-[13px] font-semibold tracking-wide text-[#8E6C2D] border border-[#B89047]/60 px-4 py-2 hover:bg-[#0B192C] hover:text-white hover:border-[#0B192C] transition-colors duration-300 cursor-pointer"
                    >
                        Schedule a Consultation
                    </button>
                </nav>

                <button
                    data-testid="nav-mobile-toggle"
                    className="lg:hidden p-2 text-[#0B192C] cursor-pointer"
                    onClick={() => setOpen(!open)}
                    aria-label={open ? "Close menu" : "Open menu"}
                    aria-expanded={open}
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <nav
                    data-testid="nav-mobile-menu"
                    className="lg:hidden bg-white border-t border-slate-200/80 px-6 py-4 flex flex-col gap-1"
                    aria-label="Mobile"
                >
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`${l.testid}-mobile`}
                            onClick={() => go(l.id)}
                            className="text-left text-sm font-medium text-slate-700 py-3 border-b border-slate-100 last:border-0 cursor-pointer"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="nav-cta-schedule-mobile"
                        onClick={() => go("contact")}
                        className="mt-3 text-sm font-semibold text-[#8E6C2D] border border-[#B89047]/60 px-4 py-3 text-center cursor-pointer"
                    >
                        Schedule a Consultation
                    </button>
                </nav>
            )}
        </header>
    );
};

export default Header;
